import { render, staticRenderFns } from "./onlineLawyer.vue?vue&type=template&id=710bb62b&scoped=true&"
import script from "./onlineLawyer.vue?vue&type=script&lang=js&"
export * from "./onlineLawyer.vue?vue&type=script&lang=js&"
import style0 from "./onlineLawyer.vue?vue&type=style&index=0&id=710bb62b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710bb62b",
  null
  
)

export default component.exports